import { Navigate, useParams } from 'react-router'
import { useAuthStore } from '@/stores/useAuthStore'

/**
 * Racine `/${locale}/` — pas de landing : `app.callizy.ca` est purement
 * applicatif. Le marketing/découverte vit sur `callizy.ca` (Next).
 *
 * Comportement :
 *  - Loggué (token JWT frais) → /dashboard (AuthGuard redirigera vers /manager
 *    si le rôle est MANAGER)
 *  - Pas loggué → /login
 */
export function HomePage() {
  const { locale = 'fr' } = useParams<{ locale: string }>()
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated())

  return (
    <Navigate
      to={`/${locale}/${isAuthenticated ? 'dashboard' : 'login'}`}
      replace
    />
  )
}
